import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_LOAD_PROJECT_COLLECTIONS_BEGIN,
  APP_SETTING_LOAD_PROJECT_COLLECTIONS_SUCCESS,
  APP_SETTING_LOAD_PROJECT_COLLECTIONS_FAILURE,
  APP_SETTING_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function loadProjectCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_PROJECT_COLLECTIONS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_PROJECT_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_PROJECT_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectCollectionsError() {
  return {
    type: APP_SETTING_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_PROJECT_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadProjectCollectionsPending: true,
        loadProjectCollectionsError: null,
      };

    case APP_SETTING_LOAD_PROJECT_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadProjectCollectionsPending: false,
        loadProjectCollectionsError: null,
        projectCollections: action.data,
      };

    case APP_SETTING_LOAD_PROJECT_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadProjectCollectionsPending: false,
        loadProjectCollectionsError: action.data.error,
      };

    case APP_SETTING_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectCollectionsError: null,
      };

    default:
      return state;
  }
}
